import { render, staticRenderFns } from "./bikeSync.vue?vue&type=template&id=2fad6048&scoped=true&"
import script from "./bikeSync.vue?vue&type=script&lang=js&"
export * from "./bikeSync.vue?vue&type=script&lang=js&"
import style0 from "./bikeSync.vue?vue&type=style&index=0&id=2fad6048&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fad6048",
  null
  
)

export default component.exports